import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Users, Inbox, Layers, Dumbbell, Library, Salad,
  MessagesSquare, MessageSquareText, BookMarked, Sparkles, LogOut, Mail, ChefHat, Trophy
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ThemeToggle } from "@/components/ThemeToggle";
import { BRAND } from "@/lib/brand";

const NAV = [
  { to: "/coach", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/coach/leads", label: "Leads", icon: Inbox },
  { to: "/coach/emails", label: "Emails", icon: Mail },
  { to: "/coach/mtm", label: "MTM Method", icon: Layers },
  { to: "/coach/clients", label: "Clients", icon: Users },
  { to: "/coach/programs", label: "Programs", icon: Dumbbell },
  { to: "/coach/exercises", label: "Exercises", icon: Library },
  { to: "/coach/meals", label: "Nutrition", icon: Salad },
  { to: "/coach/recipes", label: "Recipes", icon: ChefHat },
  { to: "/coach/wins", label: "Wins", icon: Trophy },
  { to: "/coach/messages", label: "Messages", icon: MessagesSquare },
  { to: "/coach/forums", label: "Community", icon: MessageSquareText },
  { to: "/coach/resources", label: "Resources", icon: BookMarked },
  { to: "/coach/ai", label: "AI Coach", icon: Sparkles },
];

export function CoachLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-app">
      <aside
        className="fixed inset-y-0 left-0 w-64 border-r flex-col py-8 px-4 hidden lg:flex"
        style={{ background: "var(--surface-1)", borderColor: "var(--border)" }}
        data-testid="coach-sidebar"
      >
        <div className="px-3 mb-10">
          <img src="https://customer-assets.emergentagent.com/job_coach-connect-hub-2/artifacts/yotpn0t5_White%20logo%20WW.png.png"
               alt="Wellness Way with DJ" className="w-28 h-28 object-contain mb-2"
               style={{ filter: "var(--logo-filter, none)", mixBlendMode: "var(--logo-blend, normal)" }} />
          <div className="wordmark-tag mt-1">MTM · Coach</div>
          <div className="bronze-rule mt-4" />
        </div>
        <nav className="flex-1 space-y-0.5">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`coach-nav-${label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            >
              <Icon size={14} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto pt-6 border-t space-y-2" style={{ borderColor: "var(--border)" }}>
          <div className="flex items-center justify-between px-2">
            <span className="font-label text-[10px] tracking-wider truncate" style={{ color: "var(--text-secondary)" }}>
              {user?.email}
            </span>
            <ThemeToggle />
          </div>
          <button
            type="button"
            onClick={async () => { await logout(); navigate("/login"); }}
            className="nav-link w-full"
            data-testid="coach-logout"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="lg:pl-64">
        <div className="px-6 md:px-12 py-10 max-w-[1400px] mx-auto">{children}</div>
      </main>
      <div className="lg:hidden fixed top-0 inset-x-0 z-30 backdrop-blur-xl border-b px-4 py-3 flex items-center justify-between"
        style={{ background: "rgba(255,255,255,0.85)", borderColor: "var(--border)" }}>
        <div className="flex items-baseline gap-2">
          <span className="font-script text-xl">{BRAND.name}</span>
          <span className="wordmark-tag text-[9px]">{BRAND.tag}</span>
        </div>
        <ThemeToggle />
      </div>
    </div>
  );
}
